import { throwCmtsCanonicalError } from "../api/cmtsApiErrors.js";

export function requireCmtsUiAction<T extends (...args: any[]) => any>(handler: T | undefined, actionName: string): T {
  if (!handler) {
    throwCmtsCanonicalError({ code: "CMTS_ERR_SIDE_EFFECT_UNAVAILABLE", message: `${actionName} is not connected to the CMTS repository/offline API action chain.`, details: { actionName } });
  }
  return handler;
}
